import { message } from 'antd'
import { DeliveryOrderApi } from '../../../../api/Purchase/DeliveryOrder'
import DeliveryOrderLines from '../../../../components/Purchasing/DeliveryOrder/Lines/DeliveryOrderLines'
import useFetchURL from '../../../../elements/Hooks/useFetchURL'
import { pick } from 'lodash'
import React from 'react'

import useFetchList from '../../../../elements/Hooks/useFetchList'
import useModalData from '../../../../elements/Hooks/useModalData'

function DeliveryOrderLinesCont(props) {
  const { delivery, isUpdatable } = props
  const { list, fetching, fetch } = useFetchList(() => DeliveryOrderApi.getLinesByDelivery(delivery._key))

  const {
    visible,
    modalType,
    object: line,
    submitting,
    setSubmitting,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
  } = useModalData(undefined, DeliveryOrderApi.lines.update, DeliveryOrderApi.lines.remove, fetch)

  async function submit() {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await DeliveryOrderApi.lines.create({
        ...newObject,
        delivery: pick(delivery, '_id'),
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  const { data: accounts, fetching: fetchingAccounts, fetchURL: fetchAccounts } = useFetchURL(
    `foxxapi/accounts?select=_id,name,_parent`,
    undefined,
    undefined,
    undefined,
    true
  )

  const { data: centers, fetching: fetchingCenters, fetchURL: fetchCenters } = useFetchURL(
    `foxxapi/centers?select=_id,name,_parent`
  )

  console.log({ accounts })

  return (
    <DeliveryOrderLines
      {...{
        accounts,
        centers,
        list,
        isUpdatable,
        fetching,
        fetch,
        visible,
        submitting,
        delivery,
        line,
        onShow,
        onCancel,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
      }}
    />
  )
}

DeliveryOrderLinesCont.propTypes = {}
DeliveryOrderLinesCont.defaultProps = {}

export default (DeliveryOrderLinesCont)
